import {ChangeDetectionStrategy, Component, computed, inject, signal} from '@angular/core';
import {BZ_DIALOG_DATA, BzDialogRef} from '@bringoz/ui';
import {bzIconArrowRight} from '@bringoz/ui/icons';
import * as _ from 'lodash';
import {HistoryLogDialogData} from '../../../types/timekeeping-dialog.type';
import {buildHistoryRows, TimecardHistoryRow} from '../../utils/timekeeping-dialog.util';

const STATUS_HISTORY_WIDTHS: Record<string, number> = {
  'col-name': 200,
  'col-statusChange': 320,
  'col-changedBy': 220
};

const FIELD_HISTORY_WIDTHS: Record<string, number> = {
  'col-name': 170,
  'col-stopName': 150,
  'col-by': 140,
  'col-userType': 100,
  'col-stopIndex': 60,
  'col-field': 140,
  'col-previousState': 160,
  'col-currentState': 160,
  'col-note': 160
};

/**
 * Change log of one timecard - the status history, or the field changes narrowed to a stop and a field.
 */
require('../timekeeping-dialogs.scss');
@Component({
  standalone: false,
  selector: 'app-timecard-history-log-dialog',
  templateUrl: './timecard-history-log-dialog.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TimecardHistoryLogDialogComponent {

  readonly data = inject<HistoryLogDialogData>(BZ_DIALOG_DATA);
  private readonly ref = inject(BzDialogRef);

  readonly icons = {arrow: bzIconArrowRight};
  readonly isStatusHistory = this.data.filterField === 'status' && !this.data.filterEntryId;
  readonly hasFilterCaption = !this.isStatusHistory && !!(this.data.filterField || this.data.filterEntryId);
  readonly defaultWidths = this.isStatusHistory ? STATUS_HISTORY_WIDTHS : FIELD_HISTORY_WIDTHS;

  private readonly rows: TimecardHistoryRow[] = buildHistoryRows(this.data);

  readonly searchQuery = signal('');

  /** Matches any value of the row, like the AngularJS `filter` it replaces. */
  readonly filteredRows = computed(() => {
    const query = _.toLower(this.searchQuery());
    if (!query) {
      return this.rows;
    }
    return this.rows.filter((row) => _.some(_.values(row), (value) => _.includes(_.toLower(_.toString(value)), query)));
  });

  onCancel() {
    this.ref.close();
  }
}
